import styled from "styled-components";

export const DaySpan = styled.span`
  margin: 0 6px;
`;

export const DayBtn = styled.button`
  width: 65px;
  height: 40px;
  line-height: 40px;
  margin-right: 5px;
  border-radius: 6px;
  background-color: #1463AB;
  padding: 0;
  color: #FFFFFF;
  font-weight: 700;
`;